import { render, staticRenderFns } from "./ContactPropRemoved.vue?vue&type=template&id=b62c6dd4&scoped=true"
import script from "./ContactPropRemoved.vue?vue&type=script&lang=js"
export * from "./ContactPropRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62c6dd4",
  null
  
)

export default component.exports